import { LOCAL_STORAGE } from '../constants/local-storage';
import { isWebContext } from './is-web-context';
import { store } from '../redux/configure-store';
import { getEnvUrl } from './get-env-url';
import { env } from '../constants/app-url';

export enum GtmEventEnum {
  inactivityLogout = 'inactivityLogout',
  loading_screenShown = '00_loading_screenShown',
  loading_screenExited = '00_loading_screenExited',
  calculator_screenShown = '01_calculator_screenShown',
  calculator_helloButtonPressed = '01_calculator_helloButtonPressed',
  calculator_getButtonPressed = '01_calculator_getButtonPressed',
  signUp_screenShown = '02_signUp_screenShown',
  signUp_continueButtonPressed = '02_signUp_continueButtonPressed',
  signUpSMS_screenShown = '03_signUpSMS_screenShown',
  signUpSMS_backButtonPressed = '03_signUpSMS_backButtonPressed',
  signUpSMS_continueButtonPressed = '03_signUpSMS_continueButtonPressed',
  createPassword_screenShown = '04_createPassword_screenShown',
  createPassword_createButtonPressed = '04_createPassword_createButtonPressed',
  instruction_screenShown = '05_instruction_screenShown',
  instruction_screenClosed = '05_instruction_screenClosed',
  instruction_startButtonPressed = '05_instruction_startButtonPressed',
  jumio_screenShown = '06_jumio_screenShown',
  jumio_screenClosed = '06_jumio_screenClosed',
  jumio_SDKFinished = '06_jumio_SDKFinished',
  jumio_screenExited = '06_jumio_screenExited',
  jumio_workflowRetry = '06_JSDK_workflowRetry',
  jumio_workflowFailed = '06_JSDK_workflowFailed',
  jumio_workflowStart = '06_JSDK_workflowStart',
  jumio_sdkTokenRequest = '06_jumio_sdkTokenRequest',
  jumio_sdkTokenSuccess = '06_jumio_sdkTokenSuccess',
  id_screenShown = '07_ID_screenShown',
  id_cofirmButtonPressed = '07_ID_cofirmButtonPressed',
  app_approved = 'app_approved',
  app_completed = 'app_completed',
  paymentDestinition_screenShown = '08_paymentDestinition_screenShown',
  paymentDestinition_accountValidationErrorShown = '08_paymentDestinition_accountValidationErrorShown',
  paymentDestinition_cofirmButtonPressed = '08_paymentDestinition_cofirmButtonPressed',
  LoanApplication_screenShown = '09_LoanApplication_screenShown',
  LoanApplication_geolocationReceived = '09_LoanApplication_geolocationReceived',
  LoanApplication_geolocationFailed = '09_LoanApplication_geolocationFailed',
  LoanApplication_continueButtonPressed = '09_LoanApplication_continueButtonPressed',
  confirmLoanApplicationSMS_screenShown = '10_confirmLoanApplicationSMS_screenShown',
  confirmLoanApplicationSMS_wrongSMSErrorShown = '10_confirmLoanApplicationSMS_wrongSMSErrorShown',
  confirmLoanApplicationSMS_continueButtonPressed = '10_confirmLoanApplicationSMS_continueButtonPressed',
  processingApplication_screenShown = '11_processingApplication_screenShown',
  processingApplication_screenExited = '11_processingApplication_screenExited',
  loanApproved_screenShown = '12_loanApproved_screenShown',
  loanApproved_SMSCodeButtonPressed = '12_loanApproved_SMSCodeButtonPressed',
  loanApproved_canselButtonPressed = '12_loanApproved_canselButtonPressed',
  loanApprovedSMS_screenShown = '13_loanApprovedSMS_screenShown',
  loanApprovedSMS_wrongSMSErrorShown = '13_loanApprovedSMS_wrongSMSErrorShown',
  loanApprovedSMS_continueButtonPressed = '13_loanApprovedSMS_continueButtonPressed',
  successScreen_screenShown = '14_successScreen_screenShown',
  successScreen_OKButtonPressed = '14_successScreen_OKButtonPressed',
  mainScreen_calculatorShown = '15_mainScreen_calculatorShown',
  mainScreen_partnersListShown = '15_mainScreen_partnersListShown',
  mainScreen_calculatorTakeOutALoanButtonPressed = '15_mainScreen_calculatorTakeOutALoanButtonPressed',
  jumio_SDK_1_Start = '06_JSDK_1_Start',
  jumio_SDK_2_ShownConsentMessage = '06_JSDK_2_ShownConsentMessage',
  jumio_SDK_3_ClickedStartButton = '06_JSDK_3_ClickedStartButton',
  jumio_SDK_4_CameraAccessRequest = '06_JSDK_4_CameraAccessRequest',
  jumio_SDK_CameraAccessGranted = '06_JSDK_CameraAccessGranted',
  jumio_SDK_CameraAccessDenied = '06_JSDK_CameraAccessDenied',
  jumio_SDK_StartedCameraStream = '06_JSDK_StartedCameraStream',
  jumio_SDK_IDCaptureFrontStart = '06_JSDK_5_IDCaptureFrontStart',
  jumio_SDK_5_IDCaptureScreenFrontFinish = '06_JSDK_6_IDCaptureFrontFinish',
  jumio_SDK_5_IDCaptureBackStart = '06_JSDK_7_IDCaptureBackStart',
  jumio_SDK_6_IDCaptureScreenFrontComplete = '06_JSDK_8_IDCaptureBackFinish',
  jumio_SDK_7_IDCaptureScreenFrontUpload = '06_JSDK_9_IDCaptureUpload',
  jumio_SDK_8_IDFacemapIdentityStart = '06_JSDK_10_FacemapIdentityStart',
  jumio_SDK_9_FacemapIdentityJumioStandardCaptureScreenCaptureFinish = '06_JSDK_11_FacemapIdentityFinish',
  jumio_SDK_10_FacemapIdentityJumioStandardCaptureScreenCaptureUpload = '06_JSDK_12_FacemapIdentityUpload',
  jumio_SDK_11_FacemapIdentityJumioStandardUsabilityCheck = '06_JSDK_13_FacemapUsabilityCheck',
  jumio_SDK_12_Finish = '06_JSDK_14_Finish',
  jumio_SDK_15_IDUsabilityCheckFailure = '06_JSDK_15_IDUsabilityCheckFailure',
  jumio_tokenError = '06_jumio_sdkTokenError',
  createPassword_passwordFieldTouched = '04_createPassword_passwordFieldTouched',
  createPassword_passwordStartedEnter = '04_createPassword_passwordStartedEnter',
  createPassword_passwordFieldFailedConditions = '04_createPassword_passwordFieldFailedConditions',
  createPassword_passwordFailedConfirmation = '04_createPassword_passwordFailedConfirmation',
  createPassword_passwordFieldConfirmationTouched = '04_createPassword_passwordFieldConfirmationTouched',
  createPassword_crossButtonPressed = '04_createPassword_crossButtonPressed',
  createPassword_loadingShown = '04_createPassword_loadingShown',
  ID_crossButtonPressed = '07_ID_crossButtonPressed',
  ID_firstSecondNameTouched = '07_ID_firstSecondNameTouched',
  ID_fathersLastNameTouched = '07_ID_fathersLastNameTouched',
  ID_mothersLastNameTouched = '07_ID_mothersLastNameTouched',
  ID_genderTouched = '07_ID_genderTouched',
  ID_dateOfBirthTouched = '07_ID_dateOfBirthTouched',
  ID_claveTouched = '07_ID_claveTouched',
  ID_curpTouched = '07_ID_curpTouched',
  ID_rfcTouched = '07_ID_rfcTouched',
  ID_placeOfBirthTouched = '07_ID_placeOfBirthTouched',
  ID_occupationTouched = '07_ID_occupationTouched',
  ID_emailTouched = '07_ID_emailTouched',
  ID_firstSecondNameStartedEnter = '07_ID_firstSecondNameStartedEnter',
  ID_fathersLastNameStartedEnter = '07_ID_fathersLastNameStartedEnter',
  ID_mothersLastNameStartedEnter = '07_ID_mothersLastNameStartedEnter',
  ID_genderStartedEnter = '07_ID_genderStartedEnter',
  ID_DateOfBirthStartedEnter = '07_ID_DateOfBirthStartedEnter',
  ID_curpStartedEnter = '07_ID_curpStartedEnter',
  ID_claveStartedEnter = '07_ID_claveStartedEnter',
  ID_rfcStartedEnter = '07_ID_rfcStartedEnter',
  ID_placeOfBirthStartedEnter = '07_ID_placeOfBirthStartedEnter',
  ID_occupationStartedEnter = '07_ID_occupationStartedEnter',
  ID_emailStartedEnter = '07_ID_emailStartedEnter',
  ID_claveErrorShown = '07_ID_claveErrorShown',
  ID_curpErrorShown = '07_ID_curpErrorShown',
  ID_rfcErrorShown = '07_ID_rfcErrorShown',
  ID_placeOfBirthErrorShown = '07_ID_placeOfBirthErrorShown',
  ID_emailErrorShown = '07_ID_emailErrorShown',
  ID_rfcFilled = '07_ID_rfcFilled',
  ID_placeOfBirthFilled = '07_ID_placeOfBirthFilled',
  ID_emailFilled = '07_ID_emailFilled',
  inProgress_screenShown = '16_inProgress_screenShown',
  touchBar_homePressed = '17_touchBar_homePressed',
  touchBar_historyPressed = '17_touchBar_historyPressed',
  touchBar_chatPressed = '17_touchBar_chatPressed',
  touchBar_settingsPressed = '17_touchBar_settingsPressed',
  ID_loaderShown = '07_ID_loaderShown',
  signUp_backButtonPressed = '02_signUp_backButtonPressed',
  signUp_existingPhoneScreenShown = '02_signUp_existingPhoneScreenShown',
  jumioRetry_screenShown = '06_jumioRetry_screenShown',
  jumioRetry_continuePressed = '06_jumioRetry_continuePressed',
  ID_screenExited = '07_ID_screenExited',
  ID_screenContinue = '07_ID_screenContinue',
  paymentDestinition_crossButtonPressed = '08_paymentDestinition_crossButtonPressed',
  LoanApplication_crossButtonPressed = '09_LoanApplication_crossButtonPressed',
  confirmLoanApplicationSMS_backButtonPressed = '10_confirmLoanApplicationSMS_backButtonPressed',
  loanApproved_crossButtonPressed = '12_loanApproved_crossButtonPressed',
  loanApprovedSMS_backButtonPressed = '13_loanApprovedSMS_backButtonPressed',
  mainScreen_applicationVidgetShow = '15_mainScreen_applicationVidgetShow',
  mainScreen_loanVidgetShown = '15_mainScreen_loanVidgetShown',
  mainScreen_partnerPressed = '15_mainScreen_partnerPressed',
  mainScreen_canselApplicationPressed = '15_mainScreen_canselApplicationPressed',
  mainScreen_canselApplicationApproved = '15_mainScreen_canselApplicationApproved',
  mainScreen_canselApplicationDeclined = '15_mainScreen_canselApplicationDeclined',
  login_screenShown = '18_login_screenShown',
  rejectedScreen_screenShown = '19_rejectedScreen_screenShown',
  rejectedScreen_homeButtonPressed = '19_rejectedScreen_homeButtonPressed',
  rejectedScreen_partnerPressed = '19_rejectedScreen_partnerPressed',
  moratoriumScreen_screenShown = '19_moratoriumScreen_screenShown',
  moratoriumScreen_homeButtonPressed = '19_moratoriumScreen_homeButtonPressed',
  rmoratoriumScreen_partnerPressed = '19_rmoratoriumScreen_partnerPressed',

  nubarium_screenShown = '06_nubarium_screenShown',
  nubarium_screenClosed = '06_nubarium_screenClosed',
  nubarium_sdkTokenError = '06_nubarium_sdkTokenError',
  NSDK_CameraAccessDenied = '06_NSDK_CameraAccessDenied',
  NSDK_StartedCameraStream = '06_NSDK_StartedCameraStream',
  NSDK_1_IDCaptureSuccess = '06_NSDK_1_IDCaptureSuccess',
  NSDK_2_IDCaptureFail = '06_NSDK_2_IDCaptureFail',
  NSDK_3_IDCaptureError = '06_NSDK_3_IDCaptureError',
  NSDK_4_FacemapIdentitySuccess = '06_NSDK_4_FacemapIdentitySuccess',
  NSDK_5_FacemapIdentityFail = '06_NSDK_5_FacemapIdentityFail',
  NSDK_6_FacemapIdentityError = '06_NSDK_6_FacemapIdentityError',
  NSDK_7_RetryEnded = '06_NSDK_7_RetryEnded',
  NSDK_8_Finish = '06_NSDK_8_Finish',
  nubarium_screenExited = '06_nubarium_screenExited',
  nubariumRetry_modalShown = '06_nubariumRetry_modalShown',
  nubariumRetry_tryAgainPressed = '06_nubariumRetry_tryAgainPressed',
  nubariumRetry_cancelPressed = '06_nubariumRetry_cancelPressed',
  signIn_buttonPressed = '01_signIn_buttonPressed',
  signUp_loadingShown = '02_signUp_loadingShown',
  login_buttonPressed = '18_login_buttonPressed',
  error_screen_shown = 'error_screen_shown',

  signUpNew_screenShown = '02_signUpNew_screenShown',
  signUpNew_loadingShown = '02_signUpNew_loadingShown',
  signUpNew_phoneFieldTouched = '02_signUpNew_phoneFieldTouched',
  signUpNew_phoneFieldFullyEntered = '02_signUpNew_phoneFieldFullyEntered',
  signUpNew_termsAndConditionsPressed = '02_signUpNew_termsAndConditionsPressed',
  signUpNew_privacyPolicyPressed = '02_signUpNew_privacyPolicyPressed',
  signUpNew_PEPFlagSet = '02_signUpNew_PEPFlagSet',
  signUpNew_passwordFieldTouched = '02_signUpNew_passwordFieldTouched',
  signUpNew_passwordFieldFullyEntered = '02_signUpNew_passwordFieldFullyEntered',
  signUpNew_getSMSButtonPressed = '02_signUpNew_getSMSButtonPressed',
  signUpNew_SMSFieldTouched = '02_signUpNew_SMSFieldTouched',
  signUpNew_SMSFieldFullyEntered = '02_signUpNew_SMSFieldFullyEntered',
  signUpNew_confirmButtonPressed = '02_signUpNew_confirmButtonPressed',
  signUpNew_backButtonPressed = '02_signUpNew_backButtonPressed',
  signUpNew_resendSMSButtonPressed = '02_signUpNew_resendSMSButtonPressed',
  signUpNew_SMSErrorDisplayed = '02_signUpNew_SMSErrorDisplayed',
}

const appIdEvents = [
  GtmEventEnum.instruction_screenShown,
  GtmEventEnum.instruction_screenClosed,
  GtmEventEnum.instruction_startButtonPressed,
  GtmEventEnum.jumio_screenShown,
  GtmEventEnum.jumio_screenClosed,
  GtmEventEnum.jumio_SDK_1_Start,
  GtmEventEnum.jumio_SDK_2_ShownConsentMessage,
  GtmEventEnum.jumio_SDK_3_ClickedStartButton,
  GtmEventEnum.jumio_SDK_4_CameraAccessRequest,
  GtmEventEnum.jumio_SDK_CameraAccessGranted,
  GtmEventEnum.jumio_SDK_CameraAccessDenied,
  GtmEventEnum.jumio_SDK_StartedCameraStream,
  GtmEventEnum.jumio_SDK_IDCaptureFrontStart,
  GtmEventEnum.jumio_SDK_5_IDCaptureScreenFrontFinish,
  GtmEventEnum.jumio_SDK_5_IDCaptureBackStart,
  GtmEventEnum.jumio_SDK_6_IDCaptureScreenFrontComplete,
  GtmEventEnum.jumio_SDK_7_IDCaptureScreenFrontUpload,
  GtmEventEnum.jumio_SDK_8_IDFacemapIdentityStart,
  GtmEventEnum.jumio_SDK_9_FacemapIdentityJumioStandardCaptureScreenCaptureFinish,
  GtmEventEnum.jumio_SDK_10_FacemapIdentityJumioStandardCaptureScreenCaptureUpload,
  GtmEventEnum.jumio_SDK_11_FacemapIdentityJumioStandardUsabilityCheck,
  GtmEventEnum.jumio_SDK_12_Finish,
  GtmEventEnum.jumio_SDKFinished,
  GtmEventEnum.jumio_workflowRetry,
  GtmEventEnum.jumio_workflowFailed,
  GtmEventEnum.jumio_screenExited,
  GtmEventEnum.jumioRetry_screenShown,
  GtmEventEnum.jumioRetry_continuePressed,
  GtmEventEnum.ID_loaderShown,
  GtmEventEnum.id_screenShown,
  GtmEventEnum.ID_crossButtonPressed,
  GtmEventEnum.ID_screenExited,
  GtmEventEnum.ID_screenContinue,
  GtmEventEnum.ID_firstSecondNameTouched,
  GtmEventEnum.ID_fathersLastNameTouched,
  GtmEventEnum.ID_mothersLastNameTouched,
  GtmEventEnum.ID_genderTouched,
  GtmEventEnum.ID_dateOfBirthTouched,
  GtmEventEnum.ID_claveTouched,
  GtmEventEnum.ID_rfcTouched,
  GtmEventEnum.ID_placeOfBirthTouched,
  GtmEventEnum.ID_occupationTouched,
  GtmEventEnum.ID_emailTouched,
  GtmEventEnum.ID_curpTouched,
  GtmEventEnum.ID_firstSecondNameStartedEnter,
  GtmEventEnum.ID_fathersLastNameStartedEnter,
  GtmEventEnum.ID_mothersLastNameStartedEnter,
  GtmEventEnum.ID_genderStartedEnter,
  GtmEventEnum.ID_DateOfBirthStartedEnter,
  GtmEventEnum.ID_claveStartedEnter,
  GtmEventEnum.ID_rfcStartedEnter,
  GtmEventEnum.ID_placeOfBirthStartedEnter,
  GtmEventEnum.ID_occupationStartedEnter,
  GtmEventEnum.ID_emailStartedEnter,
  GtmEventEnum.ID_curpStartedEnter,
  GtmEventEnum.ID_claveErrorShown,
  GtmEventEnum.ID_rfcErrorShown,
  GtmEventEnum.ID_placeOfBirthErrorShown,
  GtmEventEnum.ID_emailErrorShown,
  GtmEventEnum.ID_curpErrorShown,
  GtmEventEnum.ID_rfcFilled,
  GtmEventEnum.ID_placeOfBirthFilled,
  GtmEventEnum.ID_emailFilled,
  GtmEventEnum.id_cofirmButtonPressed,
  GtmEventEnum.paymentDestinition_screenShown,
  GtmEventEnum.paymentDestinition_crossButtonPressed,
  GtmEventEnum.paymentDestinition_accountValidationErrorShown,
  GtmEventEnum.paymentDestinition_cofirmButtonPressed,
  GtmEventEnum.LoanApplication_screenShown,
  GtmEventEnum.LoanApplication_crossButtonPressed,
  GtmEventEnum.LoanApplication_geolocationReceived,
  GtmEventEnum.LoanApplication_geolocationFailed,
  GtmEventEnum.LoanApplication_continueButtonPressed,
  GtmEventEnum.confirmLoanApplicationSMS_screenShown,
  GtmEventEnum.confirmLoanApplicationSMS_backButtonPressed,
  GtmEventEnum.confirmLoanApplicationSMS_wrongSMSErrorShown,
  GtmEventEnum.confirmLoanApplicationSMS_continueButtonPressed,
  GtmEventEnum.processingApplication_screenShown,
  GtmEventEnum.processingApplication_screenExited,
  GtmEventEnum.loanApproved_screenShown,
  GtmEventEnum.loanApproved_crossButtonPressed,
  GtmEventEnum.loanApproved_SMSCodeButtonPressed,
  GtmEventEnum.loanApproved_canselButtonPressed,
  GtmEventEnum.loanApprovedSMS_screenShown,
  GtmEventEnum.loanApprovedSMS_backButtonPressed,
  GtmEventEnum.loanApprovedSMS_wrongSMSErrorShown,
  GtmEventEnum.loanApprovedSMS_continueButtonPressed,
  GtmEventEnum.successScreen_screenShown,
  GtmEventEnum.successScreen_OKButtonPressed,
  GtmEventEnum.mainScreen_canselApplicationPressed,
  GtmEventEnum.mainScreen_canselApplicationApproved,
  GtmEventEnum.mainScreen_canselApplicationDeclined,
  GtmEventEnum.inProgress_screenShown,
  GtmEventEnum.rejectedScreen_screenShown,
  GtmEventEnum.rejectedScreen_homeButtonPressed,
  GtmEventEnum.rejectedScreen_partnerPressed,
  GtmEventEnum.moratoriumScreen_screenShown,
  GtmEventEnum.moratoriumScreen_homeButtonPressed,
  GtmEventEnum.rmoratoriumScreen_partnerPressed,
  GtmEventEnum.jumio_tokenError,
  GtmEventEnum.jumio_workflowStart,
  GtmEventEnum.jumio_sdkTokenSuccess,
  GtmEventEnum.jumio_sdkTokenRequest,
];

export const sendGtmEvent = (eventName: GtmEventEnum, params?: { [key in string]: any }) => {
  const source = isWebContext ? 'pwa' : 'mobile';
  const gaidLocal = localStorage.getItem(LOCAL_STORAGE.gaid);
  const gaidCookie = document.cookie
    ?.split(';')
    ?.find((item) => item.trim().startsWith('_ga='))
    ?.trim()
    ?.slice(4);

  const gaid = gaidLocal || gaidCookie;
  const date = new Date().toISOString().replace('T', ' ').replace('Z', '');

  const applicationID = store?.getState()?.app?.applicationId;
  const isAppIdInclude = store?.getState()?.app?.applicationId && appIdEvents.includes(eventName);
  const { currentEnv } = getEnvUrl();
  const startReq = [env.DEV, env.LOCAL, env.LOCAL_MOBILE].includes(currentEnv);

  const payload = {
    event_dttm: date,
    source,
    ...(gaid && { gaid }),
    ...(isAppIdInclude && { applicationID }),
  };

  if (startReq) {
    // eslint-disable-next-line
    console.log({ event: eventName, ...payload, ...params });
  }

  if (window?.dataLayer) {
    window.dataLayer?.push({ event: eventName, ...payload, ...params });
  }
};
